// Coverage-capture API client (wireframe S1) — admission-scoped, mounted
// under /api/ip (backend/routes/ip/admission-record.js), not /api/claims.
// Kept in the claims feature folder because the screen and the design doc
// both treat coverage as part of the claims domain, same as types.ts already
// does for Claim shapes that live on other tables.
import { api } from '@/lib/api/client';
import type { Coverage, CoverageInput, CoverageSaveResult, PayerScheme } from './coverageTypes';

export function fetchPayerSchemes(): Promise<PayerScheme[]> {
  return api.get('/ip/payer-schemes');
}

export function fetchAdmissionPayers(admissionId: number): Promise<Coverage[]> {
  return api.get(`/ip/admissions/${admissionId}/payers`);
}

export function createCoverage(admissionId: number, input: CoverageInput): Promise<CoverageSaveResult> {
  return api.post(`/ip/admissions/${admissionId}/payers`, input);
}

export function updateCoverage(coverageId: number, input: Partial<CoverageInput>): Promise<CoverageSaveResult> {
  return api.patch(`/ip/payers/${coverageId}`, input);
}

export function verifyCoverageId(coverageId: number): Promise<Coverage> {
  return api.post(`/ip/payers/${coverageId}/verify-id`, {});
}

export function deleteCoverage(coverageId: number): Promise<void> {
  return api.delete(`/ip/payers/${coverageId}`);
}
